// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1s1IH","title":"Header_title__1EBI1","side":"Header_side__32XGH"};